import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-input-field',
  imports: [ReactiveFormsModule, FormlyModule, TranslatePipe],
  templateUrl: './input-field.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './input-field.component.css',
})
export class InputFieldComponent extends FieldType<FieldTypeConfig> {}
